import React, { FC } from 'react';
import { ScrollView, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import Selector from '@styles/selectors';
import { getBoxShadowStyle } from '@styles/shadow';
import { DashboardScope } from '@api/domain/types';
import { ContainerStyle } from '@interfaces/base';

import { DASHBOARD_SCOPE_OPTIONS } from '@v2/pages/dashboard/common/constants/selections';
import { isPhone } from '@helpers';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export interface DashboardScopeTabsProps extends WithColor, ContainerStyle {
  scope: DashboardScope;
  onSelectScope: (scope: DashboardScope) => void;
  testIDForTab?: (scope: DashboardScope) => string;
}

const DashboardScopeTabs: FC<DashboardScopeTabsProps> = ({ C, scope, onSelectScope, testIDForTab, containerStyle }) => {
  const shadow = getBoxShadowStyle({ C, type: 'Field' });

  const tabs = DASHBOARD_SCOPE_OPTIONS.map(({ value, label }) => (
    <Selector
      key={value}
      variant={isPhone ? 'M' : 'L'}
      text={label}
      selected={scope === value}
      onPress={() => onSelectScope(value)}
      testID={testIDForTab?.(value)}
    />
  ));

  const innerStyle = [
    !isPhone && shadow,
    {
      flexDirection: 'row' as const,
      alignSelf: 'center' as const,
      backgroundColor: C('Background/Light/Tertiary'),
      borderRadius: scale(SCREEN_BORDER_RADIUS),
      padding: scale(2),
    },
  ];

  if (isPhone) {
    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }}
        style={containerStyle}
      >
        <View style={innerStyle}>{tabs}</View>
      </ScrollView>
    );
  }

  return <View style={[...innerStyle, containerStyle]}>{tabs}</View>;
};

export default ColorWrapper(DashboardScopeTabs);
